import { render, staticRenderFns } from "./RedirectExternalLinks.vue?vue&type=template&id=2c2ea4a5&scoped=true"
import script from "./RedirectExternalLinks.vue?vue&type=script&lang=js"
export * from "./RedirectExternalLinks.vue?vue&type=script&lang=js"
import style0 from "./RedirectExternalLinks.vue?vue&type=style&index=0&id=2c2ea4a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ea4a5",
  null
  
)

export default component.exports